/**
 * Stock Indicator Component
 *
 * Displays stock availability with visual indicators
 */

interface StockIndicatorProps {
  stock: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export const StockIndicator = ({
  stock,
  size = 'md',
  showLabel = true,
}: StockIndicatorProps) => {
  const getStockStatus = () => {
    if (stock === 0) return { label: 'Out of Stock', color: 'text-red-600', dotColor: 'bg-red-500' };
    if (stock <= 3) return { label: 'Low Stock', color: 'text-orange-600', dotColor: 'bg-orange-500' };
    return { label: 'In Stock', color: 'text-green-600', dotColor: 'bg-green-500' };
  };

  const status = getStockStatus();

  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  const dotSizes = {
    sm: 'w-2 h-2',
    md: 'w-2.5 h-2.5',
    lg: 'w-3 h-3',
  };

  return (
    <div className={`flex items-center gap-2 ${sizeClasses[size]}`}>
      <span className={`w-${dotSizes[size]} h-${dotSizes[size]} ${status.dotColor} rounded-full`} />
      {showLabel && (
        <span className={`font-medium ${status.color}`}>
          {status.label}
          {stock > 0 && stock <= 5 && ` (${stock} left)`}
        </span>
      )}
    </div>
  );
};
